import { Link } from "react-router-dom";
import { Star, ArrowRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { getTestimonialsForSlug } from "@/lib/service-testimonials";

interface Props { slug: string; eyebrow: string; }

const ServiceTestimonials = ({ slug, eyebrow }: Props) => {
  const items = getTestimonialsForSlug(slug);
  if (!items.length) return null;

  return (
    <section className="py-14 md:py-20 bg-card">
      <div className="container">
        <div className="text-center mb-10">
          <span className="text-eyebrow text-primary">Patient Stories</span>
          <h2 className="font-heading text-2xl md:text-3xl font-light mt-2">
            What Kalyan patients say about {eyebrow}
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <Card key={i}>
              <CardContent className="p-6">
                <div className="flex gap-0.5 mb-3">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <Star key={j} className="h-4 w-4 fill-primary text-primary" />
                  ))}
                </div>
                <p className="text-sm text-muted-foreground mb-4 italic leading-relaxed">"{t.review}"</p>
                <div>
                  <p className="font-heading font-semibold text-sm">{t.name}</p>
                  <p className="text-xs text-muted-foreground">{t.location} · {t.treatment}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link to="/testimonials" className="inline-flex items-center gap-1 text-sm font-heading text-primary hover:underline">
            Read more patient stories <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServiceTestimonials;